import { useContext } from 'react';

import { XYChartVisibleAxesScalesContext } from '../context/axes/XYChartVisibleAxesScales.context.js';

export const useVisibleAxesScales = () => {
  const context = useContext(XYChartVisibleAxesScalesContext);

  if (context === undefined) {
    throw new Error(
      'useVisibleAxesScales must be used within a XYChartVisibleAxesScalesContext',
    );
  }

  return context;
};
